import { render, staticRenderFns } from "./DriverProfile.vue?vue&type=template&id=4feefafa&scoped=true&"
import script from "./DriverProfile.vue?vue&type=script&lang=js&"
export * from "./DriverProfile.vue?vue&type=script&lang=js&"
import style0 from "./DriverProfile.vue?vue&type=style&index=0&id=4feefafa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feefafa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAutocomplete,VBtn,VCard})
